<div 
  class="jit-tooltip"
  [style.top]="((position.top || 0)) - 8 + 'px'"
  [style.left]="position.left + 'px'"
>
  {{ tooltip }}
</div>